import { render, staticRenderFns } from "./surfaceOn.vue?vue&type=template&id=a0ccb714&"
import script from "./surfaceOn.vue?vue&type=script&lang=ts&"
export * from "./surfaceOn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports